export const addresses = {
  coinHoleProvider: "0x062659a1BeCAf767626bb34c3D1427bd1b9246c4",
  redditArtProvider: "0x403a4A6C9B94929Ff6369BC5C9E6Af04714b6f7c",
  redditToken: "0x7F9FC35f0a656B1a355bda27De5AB25f9Abd9eFb",
};
